"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slowly = void 0;
var slowly = function (doThis, howSlow) {
    if (howSlow === void 0) { howSlow = 2000; }
    var promise = new Promise(function (resolve) {
        setTimeout(function () {
            resolve(doThis());
        }, howSlow);
    });
    return promise;
};
exports.slowly = slowly;
//# sourceMappingURL=slowly.js.map